export const defaultCalendarFormat = "YYYY-MM-DD";
export const defaultCalendarPlaceholder = "dd/mm/yyyy";
